<template>
  <div>
    <h3>Edit Client</h3>
    <section>
      <div class="form-inline">
        <label for="firstName">First Name:</label>
        <div>
          <input
            name="firstName"
            id="firstName"
            type="text"
            placeholder="First Name"
            v-model="editFirstName"
          />
        </div>
      </div>
      <div class="form-inline">
        <label for="lastName">Last Name:</label>
        <div>
          <input
            name="lastName"
            id="lastName"
            type="text"
            placeholder="Last Name"
            v-model="editLastName"
          />
        </div>
      </div>
      <div class="form-inline">
        <label for="phoneNumber">Phone Number:</label>
        <div>
          <input
            name="phoneNumber"
            id="phoneNumber"
            type="text"
            placeholder="Phone Number"
            v-model="editPhoneNumber"
          />
        </div>
      </div>
      <div class="form-inline">
        <label for="office">Office:</label>
        <div>
          <model-select name="office" id="office" :options="locationOptions" v-model="locationItem"></model-select>
        </div>
      </div>
      <div class="form-inline">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
        >Edit Client</spinnerButton>
      </div>
    </section>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import { db } from "@/vendor/firebase";
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: [
    "id",
    "location",
    "locations",
    "firstName",
    "lastName",
    "phoneNumber",
    "submitLoading"
  ],
  components: {
    ModelSelect,
    spinnerButton
  },
  data() {
    return {
      locationOptions: [],
      locationItem: {},
      editFirstName: "",
      editLastName: "",
      editPhoneNumber: ""
    };
  },
  watch: {
    uid: function(val) {
      this.initData();
    }
  },
  created: function() {
    this.initData();
  },
  methods: {
    reset() {
      this.locationItem = "";
    },
    selectFromParentComponent() {
      this.locationItem = this.locationOptions[0].value;
    },
    initData: function() {
      this.locationOptions = this.locations;
      this.locationItem = this.location;
      this.editFirstName = this.firstName;
      this.editLastName = this.lastName;
      this.editPhoneNumber = this.phoneNumber;
    },
    buttonClick: function() {
      this.$emit(
        "clientButtonClick",
        this.id,
        this.locationItem,
        this.editFirstName,
        this.editLastName,
        this.editPhoneNumber
      );
    }
  }
};
</script>